import type { DOCS } from '@zotlo-shared/types';

export function getDocumentLinks(payload: {
  countryCode: string;
  lang: string;
  links: Record<string, any>
}) {
  const { countryCode, lang, links } = payload;
  let result = links?.other?.en;

  switch (countryCode) {
    case 'tr':
      result = lang === 'tr' ? links?.tr?.tr : links?.tr?.en;
      break;
    case 'ru':
      result = links?.ru?.ru;
      break;
  }

  return (result || {}) as Record<DOCS, string>;
}
